import React from "react";
import { LegalLayout, Section } from "@/pages/LegalLayout";
import { Mail, LifeBuoy } from "lucide-react";

export default function Contact() {
  return (
    <LegalLayout title="Contato">
      <Section heading="Precisa de ajuda?">
        <p>
          Estamos aqui para esclarecer dúvidas sobre o funcionamento da ferramenta Pronto.AI.
        </p>
        <div className="mt-4 flex items-start gap-3 rounded-xl border border-white/8 bg-white/[0.02] p-4">
          <LifeBuoy className="mt-0.5 h-5 w-5 shrink-0 text-violet-400" />
          <p className="text-slate-300">
            <strong className="text-white">Dúvidas sobre a compra:</strong> questões relacionadas a
            pagamento, acesso, cancelamento e reembolso são tratadas pela plataforma de checkout
            utilizada no momento da compra. As condições e canais de atendimento são apresentados
            durante o processo de pagamento.
          </p>
        </div>
        <div className="mt-3 flex items-start gap-3 rounded-xl border border-white/8 bg-white/[0.02] p-4">
          <Mail className="mt-0.5 h-5 w-5 shrink-0 text-violet-400" />
          <p className="text-slate-300">
            <strong className="text-white">Canal de contato:</strong> o e-mail de suporte oficial
            deve ser configurado pelo responsável pela loja. Enquanto isso, utilize o canal informado
            no seu comprovante de compra.
          </p>
        </div>
      </Section>
    </LegalLayout>
  );
}
